module.exports = __webpack_public_path__ + "img/menu-contribute-icon.2dd5b317.svg";